import ApiBase from 'Services/Api/ApiBase';

class Users extends ApiBase {
    route = '/admin/human-resources/users';

    /**
     * @method getStaffForms
     * @param {string} user_id
     * @return {Promise<*>}
     */
    getStaffForms = (user_id) => this.get(`${this.route}/${user_id}/staff-forms`);

    /**
     * @method getFolderOverview
     * @param {string} user_id
     * @return {Promise<*>}
     */
    getFolderOverview = (user_id) => this.get(`${this.route}/${user_id}/folder/overview`);

    /**
     * @method getFolderHoliday
     * @param {string} user_id
     * @param {number|null} year The holiday year, named by the year it ends in.
     * @return {Promise<*>}
     */
    getFolderHoliday = (user_id, year = null) => this.get(`${this.route}/${user_id}/folder/holiday`, {year});

    /**
     * @method getFolderTimesheets
     * @param {string} user_id
     * @param {string|null} month "2026-10"
     * @return {Promise<*>}
     */
    getFolderTimesheets = (user_id, month = null) => this.get(`${this.route}/${user_id}/folder/timesheets`, {month});

    /**
     * @method getFolderOtherForms
     * @param {string} user_id
     * @param {object} params {page, cms_element_id}
     * @return {Promise<*>}
     */
    getFolderOtherForms = (user_id, params = {}) => this.get(`${this.route}/${user_id}/folder/other-forms`, params);
};

export default new Users();
